import { IRowNode } from 'ag-grid-community';
import DepartmentActions from 'components/tables/data/department/DepartmentActions';
import { DepartmentRow } from 'components/tables/data/department/types';
import { DepartmentFormMode } from 'components/tables/data/department/form-presentation';

/**
 * Column for the actions.
 */
export default function ActionsColumn({
  node,
  data,
  isLeafLevel = false,
  presentationMode = 'same-tab',
  onOpenEdit,
  onOpenChild,
}: {
  node: IRowNode<DepartmentRow>;
  data: DepartmentRow;
  isLeafLevel?: boolean;
  presentationMode?: DepartmentFormMode;
  onOpenEdit?: (departmentId: number, departmentName: string) => void;
  onOpenChild?: (departmentId: number, organizationId: number) => void;
}) {
  return (
    <DepartmentActions
      {...data}
      canDiscard={data.canDiscard}
      compactOnTablet
      isLeafLevel={isLeafLevel}
      presentationMode={presentationMode}
      onOpenEdit={onOpenEdit}
      onOpenChild={onOpenChild}
      onStatusChange={(status) => node.setData({ ...data, status })}
    />
  );
}
